import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '5521999568656';
const WHATSAPP_MESSAGE = 'Olá! Quero saber mais sobre a Mentoria da WING Academy';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

const FloatingWhatsApp = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Aparece depois de scroll de 300px ou após 3s (o que ocorrer primeiro)
  useEffect(() => {
    const showAfterScroll = () => {
      if (window.scrollY > 300) setVisible(true);
    };
    window.addEventListener('scroll', showAfterScroll);
    const timer = setTimeout(() => setVisible(true), 3000);
    // Mostra tooltip 1x após aparecer (some sozinho em 5s)
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 4500);
    return () => {
      window.removeEventListener('scroll', showAfterScroll);
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  // Oculto na página do Agente IA (evita sobrepor a barra de digitação)
  if (location.pathname.startsWith('/agente')) return null;
  if (!visible) return null;

  return (
    <div className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 flex items-end gap-2 group">
      {/* Tooltip de incentivo */}
      {showTooltip && (
        <div
          data-testid="whatsapp-tooltip"
          className="hidden sm:block bg-white text-gray-900 text-sm font-medium px-4 py-2 rounded-xl shadow-lg mr-2 mb-2 animate-fadeInUp relative"
        >
          Fale com o Adeilson 👋
          <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45" />
        </div>
      )}

      {/* Botão */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Falar no WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5d] shadow-lg shadow-green-900/40 transition-all duration-300 hover:scale-110"
      >
        {/* Pulsing ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />

        {/* Ícone WhatsApp */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="white"
          className="w-7 h-7 sm:w-8 sm:h-8 relative z-10"
        >
          <path d="M16.001 3.2C9.043 3.2 3.4 8.842 3.4 15.8c0 2.214.575 4.378 1.667 6.288L3.2 28.8l6.85-1.8a12.555 12.555 0 0 0 5.951 1.515h.005c6.957 0 12.6-5.642 12.6-12.6 0-3.368-1.311-6.534-3.692-8.916A12.524 12.524 0 0 0 16 3.2Zm0 23.066h-.004a10.456 10.456 0 0 1-5.328-1.46l-.382-.227-3.954 1.038 1.057-3.857-.249-.396a10.474 10.474 0 0 1-1.604-5.564c0-5.787 4.709-10.496 10.499-10.496a10.43 10.43 0 0 1 7.422 3.076 10.43 10.43 0 0 1 3.073 7.42c0 5.788-4.708 10.466-10.53 10.466Zm5.764-7.838c-.317-.158-1.872-.924-2.162-1.029-.29-.106-.502-.158-.713.158-.21.316-.819 1.029-1.004 1.24-.185.21-.37.237-.687.079-.317-.158-1.338-.493-2.547-1.572-.941-.838-1.575-1.873-1.76-2.19-.184-.317-.02-.488.139-.646.142-.142.317-.37.475-.555.158-.185.211-.317.317-.527.106-.211.053-.396-.026-.555-.079-.158-.713-1.717-.977-2.351-.257-.617-.518-.534-.713-.543-.184-.009-.395-.011-.606-.011a1.16 1.16 0 0 0-.844.396c-.29.317-1.108 1.082-1.108 2.64s1.134 3.063 1.292 3.273c.158.211 2.234 3.41 5.41 4.781.756.326 1.346.52 1.806.665.758.241 1.448.207 1.994.126.608-.091 1.872-.765 2.137-1.504.264-.74.264-1.373.185-1.504-.079-.131-.29-.21-.607-.369Z" />
        </svg>
      </a>
    </div>
  );
};

export default FloatingWhatsApp;
